const state = {
    messages: null,
    show: false,
    isNew: false,
    page: 0,
    isLast: false
}

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    },
    setNewMessage: (state, message) => { 
        state.messages.push(message)
    },
    setOldMessages: (state, array) => {
        state.messages = array.concat(state.messages)
    },
    clear: state => {
        state.messages = [];
        state.isLast = false;
        state.page = 0;
    }
}

const actions = {
    async fetch({commit, state}) { 
        if (state.isLast) {
            return;
        }

        let page = ++state.page;
        const query = page == 1 ? '' : `?before=${state.messages[0].id}`; 

        const response = await this.$api.chat.fetch(query); 
        
        if (page == 1) {
            commit('setState', {
                key: 'messages',
                value: response.data.messages
            });
        }
        else {
            commit('setOldMessages', response.data.messages)
        }
 
        commit('setState', {
            key: 'isLast',
            value: response.data.messages.length == 0
        }); 
    },
    async send({commit}, form) {
        const response = await this.$api.chat.send(form); 

        if (response.data.message == null) {
            return;
        }
        
        commit('setNewMessage', response.data.message);
        commit('setState', {
            key: 'isNew',
            value: true
        });  
    },
    async sendImages({commit}, form) {
        form.images.forEach(image => {
            const fd = new FormData();
            fd.append('media', image.media);
            fd.append('client', form.client);

            this.$api.chat.sendImage(fd).then(res => {
                commit('setNewMessage', res.data.message);
                commit('setState', {
                    key: 'isNew',
                    value: true
                });
            });  
        });
    }
}

const getters = {
    messages: state => state.messages,
    isNew: state => state.isNew,
    show: state => state.show
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}